import { render, staticRenderFns } from "./TabelaDescricao.vue?vue&type=template&id=4d860650&scoped=true"
import script from "./TabelaDescricao.vue?vue&type=script&lang=js"
export * from "./TabelaDescricao.vue?vue&type=script&lang=js"
import style0 from "./TabelaDescricao.vue?vue&type=style&index=0&id=4d860650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d860650",
  null
  
)

export default component.exports